import {
  SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE,
  GET_COMPANY_DASHBOARD,
  SET_COMPANY_DASHBOARD_BULLION_RECORD_LOADING,
  SET_COMPANY_DASHBOARD_BULLION_RECORD,
  SET_COMPANY_DASHBOARD_METAL_ALLOCATION_LOADING,
  SET_COMPANY_DASHBOARD_METAL_ALLOCATION,
  SET_COMPANY_DASHBOARD_PROFIT_LOSS_LOADING,
  SET_COMPANY_DASHBOARD_PROFIT_LOSS,
  COMPANY_DASHBOARD_LOADING_SKELETON
} from "./types";
import stripeService from "../services/stripe.service";
import { PRODUCT_BULLION_TYPE, PRODUCT_GOLD_TYPE_NAME_INITIAL, SUPPORTED_PAYMENT_METHOD } from "../constants";
import moment from "moment";
import compnayDashboardService from "../services/compnayDashboard.service";

export const getCompanyDashboardAction = (payload) => async (dispatch) => {
  dispatch({ type: COMPANY_DASHBOARD_LOADING_SKELETON, payload: true });
  return compnayDashboardService.getCompanyDashboard(payload).then(async (resp) => {
    if (resp.status) {
      dispatch({ type: GET_COMPANY_DASHBOARD, payload: resp.status ? resp.data : {} });
      dispatch(companyDashboardBullionBalanceUpdate(resp.data?.bullionRecord))
      dispatch(companyDashboardMetalAllocationUpdate(resp.data?.metalAllocation))
    }
  }
  );
};

export const companyDashboardBullionBalanceUpdate = (payloadResp) => async (dispatch, getState) => {
  dispatch({ type: SET_COMPANY_DASHBOARD_BULLION_RECORD_LOADING, payload: true })
  // Bullion Reecord 
  if (payloadResp?.length > 0) {
    const promises = payloadResp?.map(item =>
      stripeService.currencyConverter(SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER, { from: item.currency, to: getState()?.user?.bidGoldHeaderCurrency?.value, amount: parseFloat(item.balance) })
    );
    const details = await Promise.all(promises);

    const updatedData = payloadResp?.map((item, index) => ({
      ...item,
      convertionCurrency: getState()?.user?.bidGoldHeaderCurrency?.value,
      convertionBalance: details[index]?.data // Update balance with the fetched rate
    }));
    dispatch({ type: SET_COMPANY_DASHBOARD_BULLION_RECORD, payload: updatedData || [] });
  } else {
    dispatch({ type: SET_COMPANY_DASHBOARD_BULLION_RECORD, payload: [] });
  }
  // Bullion Reecord  
};

export const companyDashboardMetalAllocationUpdate = (payloadResp) => async (dispatch, getState) => {
  dispatch({ type: SET_COMPANY_DASHBOARD_METAL_ALLOCATION_LOADING, payload: true })
  if (payloadResp?.length > 0) {
    // Metal Allocation 
    const promises = payloadResp?.map(item =>
      stripeService.currencyConverter(SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER, { from: item.currency, to: getState()?.user?.bidGoldHeaderCurrency?.value, amount: parseFloat(item.allocation) })
    );
    const details = await Promise.all(promises);

    const updatedData = payloadResp?.map((item, index) => ({
      ...item,
      convertionCurrency: getState()?.user?.bidGoldHeaderCurrency?.value,
      convertionBalance: details[index]?.data // Update balance with the fetched rate
    }));
    dispatch({ type: SET_COMPANY_DASHBOARD_METAL_ALLOCATION, payload: updatedData || [] });
    // Metal Allocation

    dispatch(companyDashboardProfitLossUpdate(updatedData))
  } else {
    dispatch({ type: SET_COMPANY_DASHBOARD_METAL_ALLOCATION, payload: [] });
    dispatch(companyDashboardProfitLossUpdate([]))
  }
};
export const companyDashboardProfitLossUpdate = (payloadResp) => async (dispatch, getState) => {
  dispatch({ type: SET_COMPANY_DASHBOARD_PROFIT_LOSS_LOADING, payload: true })
  let profitLossData = [];

  let profitAndLossGoldKilogram = 0;
  let profitAndLossGoldGram = 0;
  let profitAndLossGoldOunce = 0;
  let profitAndLossSilverKilogram = 0;
  let profitAndLossSilverGram = 0;

  let totalGram = 0
  let totalKilogram = 0
  let totalOunce = 0
  let totalSilverKilogram = 0
  let totalSilverGram = 0
  if (payloadResp?.length > 0) {
    payloadResp.forEach(element => {
      switch (element.type) {
        case PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM:
          if (parseInt(element.bullionType) === PRODUCT_BULLION_TYPE.GOLD) {
            const totalKg = parseInt(element?.quantity) * element?.convertionBalance;
            const kgGoldPrice = getState()?.user?.bidGoldHeader?.gold1kg?.price || 0;
            const totalKgGoldPrice = kgGoldPrice * parseInt(element?.quantity);
            const calcKgPrice = totalKgGoldPrice - totalKg;
            totalKilogram = parseInt(element?.metal);
            profitAndLossGoldKilogram += calcKgPrice;
          } else {
            const totalSilverKg = parseInt(element?.quantity) * element?.convertionBalance;
            const kgSilverPrice = getState()?.user?.bidSilverHeader?.silver1kg?.price || 0;
            const totalKgSilverPrice = kgSilverPrice * parseInt(element?.quantity);
            const calcKgPrice = totalKgSilverPrice - totalSilverKg;
            totalSilverKilogram = parseInt(element?.metal);
            profitAndLossSilverKilogram += calcKgPrice;
          }
          break;

        case PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM:
          if (parseInt(element.bullionType) === PRODUCT_BULLION_TYPE.GOLD) {

            const totalG = parseInt(element?.quantity) * element?.convertionBalance;
            const gGoldPrice = getState()?.user?.bidGoldHeader?.gold1g?.price || 0;
            const totalgGoldPrice = gGoldPrice * parseInt(element?.quantity);
            const calcgPrice = totalgGoldPrice - totalG;
            totalGram = parseInt(element?.metal);
            profitAndLossGoldGram += calcgPrice;
          }
          else {
            const totalSilverG = parseInt(element?.quantity) * element?.convertionBalance;
            const gSilverPrice = getState()?.user?.bidSilverHeader?.silver10g?.price || 0;
            const totalgSilverPrice = gSilverPrice * parseInt(element?.quantity);
            const calcgPrice = totalgSilverPrice - totalSilverG;
            totalSilverGram = parseInt(element?.metal);
            profitAndLossSilverGram += calcgPrice;
          }
          break;

        case PRODUCT_GOLD_TYPE_NAME_INITIAL.OUNCE:
          const totalOz = parseInt(element?.quantity) * element?.convertionBalance;
          const ozGoldPrice = getState()?.user?.bidGoldHeader?.gold1ounce?.price || 0;
          const totalOzGoldPrice = ozGoldPrice * parseInt(element?.quantity);
          const calcOzPrice = totalOzGoldPrice - totalOz;
          totalOunce = parseInt(element?.metal);
          profitAndLossGoldOunce += calcOzPrice;
          break;

        default:
          break;
      }
    });

    const asOfDate = moment().format("DD/MM/YYYY");
    const convertionCurrency = getState()?.user?.bidGoldHeaderCurrency?.value.toUpperCase();
    const formatProfitLoss = (value) => {
      if (value > 0) {
        return `+${Math.abs(value)}`; // Positive values show with '+'
      } else if (value < 0) {
        return `-${Math.abs(value)}`; // Negative values show with '-'
      } else {
        return '0.00'; // If the value is 0, show as '0.00'
      }
    };
    const hasGoldGram = payloadResp.some(item => item.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM && parseInt(item.bullionType) === PRODUCT_BULLION_TYPE.GOLD);
    const hasSilverGram = payloadResp.some(item => item.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM && parseInt(item.bullionType) === PRODUCT_BULLION_TYPE.SILVER);
    const hasGoldKilogram = payloadResp.some(item => item.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM && parseInt(item.bullionType) === PRODUCT_BULLION_TYPE.GOLD);
    const hasSilverKilogram = payloadResp.some(item => item.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM && parseInt(item.bullionType) === PRODUCT_BULLION_TYPE.SILVER);
    const hasOunce = payloadResp.some(item => item.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.OUNCE);

    // Conditionally push "Gram" and "Kilogram" data only if they have values
    if (hasGoldGram) {
      profitLossData.push({
        allocation: "Gold bullion savings plan - 1 gram denomination",
        asOf: asOfDate,
        convertionCurrency: convertionCurrency,
        ytd: formatProfitLoss(profitAndLossGoldGram),
        type: PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM,
        totalGram: totalGram
      });
    }

    if (hasSilverGram) {
      profitLossData.push({
        allocation: "Silver bullion savings plan - 10 gram denomination",
        asOf: asOfDate,
        convertionCurrency: convertionCurrency,
        ytd: formatProfitLoss(profitAndLossSilverGram),
        type: PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM,
        totalGram: totalSilverGram
      });
    }

    if (hasGoldKilogram) {
      profitLossData.push({
        allocation: "Gold bullion bars - 1 kilogram denomination - LBMA - various brands",
        asOf: asOfDate,
        convertionCurrency: convertionCurrency,
        ytd: formatProfitLoss(profitAndLossGoldKilogram),
        type: PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM,
        totalKilogram: totalKilogram
      });
    }

    if (hasSilverKilogram) {
      profitLossData.push({
        allocation: "Silver bullion bars - 1 kilogram denomination - LBMA - various brands",
        asOf: asOfDate,
        convertionCurrency: convertionCurrency,
        ytd: formatProfitLoss(profitAndLossSilverKilogram),
        type: PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM,
        totalKilogram: totalSilverKilogram
      });
    }

    if (hasOunce) {
      profitLossData.push({
        allocation: "Gold",
        asOf: asOfDate,
        convertionCurrency: convertionCurrency,
        ytd: formatProfitLoss(profitAndLossGoldOunce),
        type: PRODUCT_GOLD_TYPE_NAME_INITIAL.OUNCE,
        totalOunce: totalOunce
      });
    }
  }

  const updatedData = {
    profitLossData: profitLossData
  };

  dispatch({ type: SET_COMPANY_DASHBOARD_PROFIT_LOSS, payload: updatedData });
};

export const updateCompanyDashboardAction = (id, payload) => async (dispatch) => {
  return compnayDashboardService.updateCompanyDashboard(id, payload).then(
    (resp) => {
      dispatch({ type: resp.status ? SET_SUCCESS_MESSAGE : SET_FAILED_MESSAGE, payload: resp.data })
      dispatch(getCompanyDashboardAction(id));
    }
  );
};
